import {IDischargeDataItem} from './data-list/discharge-data-list.controller';
import {IDischargeChartPoint} from './discharge.types';
import {List, Set} from 'immutable';
import {IMomentFormatter} from '../utils/moment.formatter';
import {IDischargeCurveController} from './curve.controller';

const dischargeDataListCurveFactory:ng.IDirectiveFactory = () => {
  return {
    restrict: 'A',
    controller: DischargeDataListCurveController
  };
};
export default dischargeDataListCurveFactory;

export interface IDischargeDataListCurveController {
  addDischargeCurveController(dischargeCurveController:IDischargeCurveController):void;
  onDischargeDataItemsChange(dischargeDataItems:List<IDischargeDataItem>):void;
  onSelectedDischargeDataItemsChange(selectedDischargeDataItems:List<IDischargeDataItem>):void;
}

class DischargeDataListCurveController implements IDischargeDataListCurveController {
  static $inject = ['$filter'];

  private dischargeDataItems:List<IDischargeDataItem>;
  private selectedDischargeDataItems:Set<IDischargeDataItem>;
  private dischargeChartPoints:List<IDischargeChartPoint>;
  private momentFormatter:IMomentFormatter;
  private dischargeCurveController:IDischargeCurveController;

  constructor($filter:ng.IFilterService) {
    this.momentFormatter = $filter<IMomentFormatter>('momentFormatter');
    this.dischargeDataItems = List<IDischargeDataItem>();
    this.selectedDischargeDataItems = Set<IDischargeDataItem>();
    this.dischargeChartPoints = List<IDischargeChartPoint>();
  }

  addDischargeCurveController(dischargeCurveController:IDischargeCurveController):void {
    this.dischargeCurveController = dischargeCurveController;
  }

  onDischargeDataItemsChange(dischargeDataItems:List<IDischargeDataItem>):void {
    this.dischargeDataItems = dischargeDataItems;
    this.buildChartDataList();
  }

  onSelectedDischargeDataItemsChange(selectedDischargeDataItems:List<IDischargeDataItem>):void {
    this.selectedDischargeDataItems = Set(selectedDischargeDataItems);
    this.buildChartDataList();
  }

  private buildChartDataList() {
    this.dischargeChartPoints = this.dischargeDataItems
        .map(dischargeDataItem => {
          return {
            discharge: dischargeDataItem.discharge,
            waterLevel: dischargeDataItem.waterLevel,
            label: this.momentFormatter(dischargeDataItem.date, 'roman'),
            selected: this.selectedDischargeDataItems
                .contains(dischargeDataItem)
          }
        }).toList();
    this.notifyChart();
  }

  private notifyChart() {
    if (this.dischargeCurveController) {
      this.dischargeCurveController
          .onDischargeChartPointsChange(this.dischargeChartPoints);
    }
  }
}



/** WEBPACK FOOTER **
 ** ./app/discharge/discharge-data-list-curve.directive.ts
 **/